import axios from 'axios';

import { TASKS_DEFINITIONS_COUNT } from 'RestAPIs/endpoints';

export type DefinitionCount = {
  count: number;
  definitionKey: string;
  dynamicLabel?: string;
  date?: string;
};

type Options = {
  costCenterIds: string;
};

export const getDefinitionsCount = ({ costCenterIds }: Options) =>
  axios.get<DefinitionCount[]>(TASKS_DEFINITIONS_COUNT, {
    params: { costCenterIds }
  });
